import { isRunningInIframe } from '../isRunningInIframe/isRunningInIframe';
export async function getScale() {
  return new Promise(resolve => {
    if (isRunningInIframe()) {
      window.Wix.getBoundingRectAndOffsets(_ref => {
        let {
          scale
        } = _ref;
        return resolve(scale);
      });
    } else {
      resolve(1);
    }
  });
}
//# sourceMappingURL=getScale.js.map